import { render } from "./MySajuDeleteConfirmPopup.vue?vue&type=template&id=2f960cba&scoped=true"
import script from "./MySajuDeleteConfirmPopup.vue?vue&type=script&lang=js"
export * from "./MySajuDeleteConfirmPopup.vue?vue&type=script&lang=js"

import "./MySajuDeleteConfirmPopup.vue?vue&type=style&index=0&id=2f960cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f960cba"]])

export default __exports__